'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { ServiceCatalogEnabledContext } from './service-catalog-context';
export interface ServiceCatalogRootProps extends React.ComponentProps<'div'> {
  isEnabled: boolean;
}
function ServiceCatalogRoot(t0) {
  const $ = _c(16);
  let children;
  let className;
  let isEnabled;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      isEnabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = isEnabled;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    isEnabled = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children) {
    t2 = <div>{children}</div>;
    $[7] = children;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <div className={t1} {...props}>{t2}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== isEnabled || $[14] !== t3) {
    t4 = <ServiceCatalogEnabledContext value={isEnabled}>{t3}</ServiceCatalogEnabledContext>;
    $[13] = isEnabled;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
export { ServiceCatalogRoot };